import { InShellStatus } from "src/components/InShellStatus/InShellStatus";

interface ModuleAccessDeniedProps {
  /** The page's drawer label; omitted for a page without a nav entry. */
  pageName?: string;
}

/**
 * Shown in the shell's content area when a signed-in user opens a page they
 * aren't entitled to. Unlike AccessDeniedPage, the header and drawer stay.
 */
export function ModuleAccessDenied({ pageName }: ModuleAccessDeniedProps) {
  return (
    <InShellStatus title="Access Denied">
      You don&apos;t have access to {pageName ?? "this page"}. Contact your administrator if you
      need it.
    </InShellStatus>
  );
}
